import {UIGameMapController} from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapController.ts'
import {UIGameMapHoverController} from '../../../../shared/scripts/ui_game/ui_game_map/ui_game_map_hover/UIGameMapHoverController.ts'
import {UIGameMapView} from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapView.ts'
import {type UIWGameManager} from '../UIWGameManager.ts'

export class UIWGameMapController extends UIGameMapController {
    constructor(uiGameManager: UIWGameManager) {
        super(uiGameManager)
        this.hoverController = new UIGameMapHoverController(uiGameManager, true)
    }

    initializeMapView(): UIGameMapView {
        const canvas = this.uiGameManager.canvasController

        const width = canvas.appW - canvas.chatWidth
        const height = canvas.appH - canvas.itemSize
        return new UIGameMapView(0, 0, width, height, canvas.app)
    }

    protected resizeMapView(): void {
        const canvas = this.uiGameManager.canvasController

        const width = canvas.appW - canvas.chatWidth
        const height = canvas.appH - canvas.itemSize
        this.mapView.resize(width, height)

        this.scaleMapView()
        this.centerMapView()
    }

    private scaleMapView() {
        const canvas = this.uiGameManager.canvasController
        const canvasWidth = canvas.appW - canvas.chatWidth
        const canvasHeight = canvas.appH - canvas.itemSize

        const scaleX = canvasWidth / this.mapView.originalWidth
        const scaleY = canvasHeight / this.mapView.originalHeight
        const scaleFactor = Math.min(scaleX, scaleY)

        this.mapView.scale.set(scaleFactor)
    }

    private centerMapView() {
        this.mapView.moveCenter(0, 0)
    }
}
